import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { createPaginationParams } from 'APIPackage/MainModule/common/createPaginationParams';
import { IPaginationParams } from 'APIPackage/MainModule/interfaces/IPaginationParams';

import { INotificationResponse } from '../interfaces/INotificationResponse';
import { NotificationSearchTypeEnum } from '../../../UserNotificationPackage/MainModule/enums/NotificationSearchTypeEnum';
import { INotificationReadStatusUpdateRequest } from '../interfaces/INotificationReadStatusUpdateRequest';

interface IFetchNotification extends IPaginationParams {
  searchType: NotificationSearchTypeEnum;
  searchValue?: string;
}

export async function fetchNotification({
  searchType,
  searchValue,
  ...paginationParams
}: IFetchNotification): Promise<INotificationResponse[]> {
  const queryParams = createPaginationParams(paginationParams);

  queryParams.append('searchType', NotificationSearchTypeEnum[searchType]);

  if (searchValue) {
    queryParams.append('searchValue', searchValue);
  }

  return apiGet<INotificationResponse[]>(
    `${getServiceBaseURL(APIServiceEnum.NOTIFICATION_SERVICE)}/notification?${queryParams}`,
  );
}

export async function notificationReadStatusUpdate(request: INotificationReadStatusUpdateRequest): Promise<void> {
  const params = new URLSearchParams();

  if (request.setReadAll) {
    params.append('setReadAll', 'true');
  }

  return apiPut(
    `${getServiceBaseURL(APIServiceEnum.NOTIFICATION_SERVICE)}/notification/update-read-status?${params}`,
    request,
  );
}
